var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubePictoGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8171 6.15177C29.7319 5.04016 29.5955 3.93302 29.195 2.87945C28.6581 1.45534 27.6526 0.633911 26.2338 0.415161C24.3164 0.116054 22.3735 0.107125 20.4391 0.0669465C15.0706 -0.0446607 9.70203 -0.0580535 4.342 0.325875C2.42039 0.464268 1.1933 1.49998 0.618095 3.43302C0.226105 4.74552 0.174976 6.10266 0.102543 7.45534C-0.0508442 10.2634 -0.0295404 13.0759 0.183497 15.8839C0.268713 17.0134 0.409318 18.1339 0.81409 19.2053C1.27851 20.4286 2.14345 21.1652 3.3322 21.4955C3.98409 21.6741 4.65303 21.75 5.32197 21.7946C8.5218 22.0044 11.7259 21.9911 14.9257 21.9955C16.5618 21.9955 18.1895 22.0178 19.8213 21.9911C21.8367 21.9598 23.8477 21.8973 25.8546 21.6964C27.4992 21.5402 28.6709 20.683 29.2632 19.0178C29.7702 17.5848 29.8256 16.0803 29.9065 14.5848C30.0599 11.7768 30.0344 8.96427 29.8256 6.15623L29.8171 6.15177ZM11.9176 15.0893V6.29016C14.6275 7.7723 17.2777 9.2232 19.9918 10.7098C17.2649 12.1875 14.6147 13.6294 11.9176 15.0937V15.0893Z",
    fill: "#50545F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePictoGrey);
export default __webpack_public_path__ + "static/media/youtube-picto-grey.910772b8ff7496e618546e0e661382f6.svg";
export { ForwardRef as ReactComponent };